import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _createForOfIteratorHelper from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.unshift.js";
import * as echarts from "echarts";
import { formatTimeToStr } from "@/utils/date.js";
import { getGameCoinMap } from "@/utils/dictionary";
export default {
  props: {
    api: String,
    title: String,
    data: Array
  },
  data: function data() {
    return {
      //获取当前日期
      onLineNowDate: "",
      onLineArrTimeTitle: [1, 2, 3],
      //当前时间的数组
      onLineArrTime: [1, 2, 3],
      //前一天时间的数组
      befOnLineArrTime: [],
      //当前数量的数组
      onLineArrNum: [],
      //前一天数量的数组
      befonLineArrNum: [],
      currentValue: "",
      onLineTimeNow: [],
      onLineTimeBefore: [],
      searchInfo: {
        server_id: []
      },
      startValue: "",
      endValue: "",
      value: "按照分钟查看",
      grouping: "minute",
      timeTitle: "按照分钟查看",
      coinList: {},
      coinName: ""
    };
  },
  watch: {
    data: function data() {
      // this.initCharts()
    }
  },
  methods: {
    initCharts: function initCharts() {
      var xAxis = [];
      var yData = [[], [], []];
      var sortData = [];
      var _iterator = _createForOfIteratorHelper(this.data),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _row = _step.value;
          sortData.unshift(_row);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      for (var _i = 0, _sortData = sortData; _i < _sortData.length; _i++) {
        var row = _sortData[_i];
        xAxis.push(formatTimeToStr(row.date_str, "yyyy-MM-dd"));
        if (row.activity_user > 0) {
          yData[0].push(parseInt(row.activity_user_coin / row.activity_user));
        } else {
          yData[0].push(0);
        }
        if (row.history_pay_user > 0) {
          yData[1].push(parseInt(row.history_pay_user_coin / row.history_pay_user));
        } else {
          yData[1].push(0);
        }
        if (row.pay_user > 0) {
          yData[2].push(parseInt(row.pay_user_coin / row.pay_user));
        } else {
          yData[2].push(0);
        }
      }
      var chartDom = this.$refs.main;
      var myChart = echarts.init(chartDom);
      this.option && myChart.setOption(this.option);

      // 绘制图表

      myChart.setOption({
        tooltip: {
          trigger: 'axis'
        },
        // grid: {
        //     left: '3%',
        //     right: '4%',
        //     bottom: '3%',
        //     containLabel: true
        // },
        legend: {
          data: ['活跃用户人均' + this.coinName, '历史付费用户人均' + this.coinName, '当天付费用户人均' + this.coinName]
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: xAxis
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          name: '活跃用户人均' + this.coinName,
          type: 'line',
          data: yData[0]
        }, {
          name: '历史付费用户人均' + this.coinName,
          type: 'line',
          data: yData[1]
        }, {
          name: '当天付费用户人均' + this.coinName,
          type: 'line',
          data: yData[2]
        }]
      });
    }
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var that;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            // this.getDateTime();
            that = _this;
            _context2.next = 3;
            return getGameCoinMap();
          case 3:
            _this.coinList = _context2.sent;
            if (_this.coinList[1]) {
              _this.coinName = _this.coinList[1];
            }
            setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
              return _regeneratorRuntime().wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    that.initCharts();
                  case 1:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            })), 100);
          case 6:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  }
};